import {Component, NgZone, OnInit} from '@angular/core';
import {AppService} from '../app.service';
declare let $: any;
declare let window: any;

@Component({
  selector: 'header-portion',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {


  constructor(public app: AppService, private zone: NgZone) {

  }

  ngOnInit() {

  }

  openLoginModal() {
    console.log("Got here");
    // $('#loginModal').modal('show');
  }

  headerPos() {
    let header = document.getElementById("picThisHeader");
    let navHeader = document.getElementById("navHeader");
    let width = header.offsetWidth;
    let height = header.offsetHeight;
    let totalWidth = navHeader.offsetWidth;
    let totalHeight = navHeader.offsetHeight;
    let left = (totalWidth - width) / 2;
    let top = (totalHeight - height) / 2;
    return {top: top + 'px', left: left + 'px'};
  }

  getUserName() {
    if (this.app.user !== null) {
      if (this.app.user.login_name === "") {
        let i = this.app.user.email.indexOf("@");
        let name = this.capitalizeFirstLetter(this.app.user.email.substr(0, i));
        this.app.user.login_name = name;
        return name;
      } else {
        return this.capitalizeFirstLetter(this.app.user.login_name);
      }

    } else {
      return "(no name found)";
    }
  }

  capitalizeFirstLetter(word) {
    return word.replace(/^\w/, (c) => c.toUpperCase());
  }

  logout() {
    this.app.logOut();
  }

  changePlayingGame(val) {
    this.app.appMode = val ? 1 : 0;
    if (!val) {
      console.log("Going to sponsor page");
    }
  }

  goToAdminConsole() {
    this.app.appMode = 3;
    this.app.broadcast({event: 'loadAdminConsole'});
  }

  goToHomePage() {
    this.app.appMode = 4;
    this.app.broadcast({event: 'loadHomePage'});
  }

  goToCardCreatorConsole() {
    this.app.appMode = 0;
  }

  goToSponsorConsole() {
    this.app.appMode = 2;
    this.app.broadcast({event: 'loadSponsorConsole'});
  }

  accountSetup() {
    $('#updateAccountModal').modal('show');
  }
}
